import { SectionWrapper } from '../../components/SectionWrapper';

import styles from './HumanitiesClassroomSection.module.css';

export function HumanitiesClassroomSection() {
  return (
    <SectionWrapper background="white" data-testid="humanities-section-classroom">
      <div className={styles.section}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>IN THE CLASSROOM</p>
          <h2 className={styles.title}>Already in the classroom</h2>
        </div>

        <div className={styles.prose}>
          <p>
            Kudu Humanities is not a theoretical project exploring what AI might
            someday do for education. Our work is embedded in real university
            classrooms — supporting real faculty and students across a growing
            range of humanities disciplines at institutions including UCLA.
          </p>
          <p>
            Through AI-integrated courses, custom textbooks, contextual learning
            systems, and writing support tools, we are testing, refining, and
            implementing practical approaches that respond to the realities of
            contemporary higher education. Each course becomes an opportunity to
            evaluate how AI can meaningfully support student learning while
            preserving the intellectual rigor, disciplinary expertise, and human
            relationships that define great education.
          </p>
        </div>
      </div>
    </SectionWrapper>
  );
}
